import React, { ReactElement } from 'react';
import { Squad } from 'api/models';
import { TemplateAssigneePicker } from 'components/molecules/assignee-picker/template-assignee-picker';
import styles from 'components/molecules/tasks/task-table/tasks-table.module.css';
import { ProjectTemplateTask } from 'data/templates/projects';
import { useTranslation } from 'hooks/use-translation';
import { MoreActionsCell } from './more-actions-cell';
import { StatusIndicatorCell } from './status-indicator-cell';

export const useTableConfig = (
  docId: number,
  resourceSectionId: number,
  handleAssigneeChange: (taskId: number, selected: Squad) => void,
  onDelete: (record: ProjectTemplateTask) => void,
  readOnly?: boolean,
): {
  title: string;
  className?: string;
  dataIndex?: string;
  key?: string;
  ellipsis?: boolean;
  width?: string;
  render: (text: string, record: Partial<ProjectTemplateTask>) => ReactElement;
}[] => {
  const columnConfig = [
    {
      title: 'Tasks',
      dataIndex: 'taskName',
      key: 'taskName',
      ellipsis: true,
      render: (text: string, record: Partial<ProjectTemplateTask>) => (
        <StatusIndicatorCell
          docId={docId}
          readOnly={readOnly}
          resourceSectionId={resourceSectionId}
          text={text}
          task={record as ProjectTemplateTask}
        />
      ),
    },
    {
      title: useTranslation('assigned_to'),
      className: styles.assignee,
      render: (_, record: Partial<ProjectTemplateTask>) => (
        <TemplateAssigneePicker
          readOnly={!record.taskId || readOnly}
          value={record.assignee}
          onDone={(selected) =>
            record.taskId ? handleAssigneeChange(record.taskId, selected) : null
          }
        />
      ),
    },
    {
      title: '',
      width: '40px',
      render: (_, record) =>
        readOnly ? (
          <></>
        ) : (
          <MoreActionsCell record={record} onDelete={onDelete} />
        ),
    },
  ];

  return columnConfig;
};
